import { BaseApi } from '@/shared/api/baseApi';
import { ENTITY_CONFIGS } from '@/shared/constants/entities';
import type { AuditLog } from '@/shared/types/auditLog';

const auditLogsApiInstance = new BaseApi<AuditLog, never>(ENTITY_CONFIGS.auditLogs.endpoints);

export const auditLogsApi = {
  getList: auditLogsApiInstance.getList.bind(auditLogsApiInstance),
  getOne: () => Promise.reject(new Error('Audit logs are read-only')),
  create: () => Promise.reject(new Error('Audit logs are read-only')),
  update: () => Promise.reject(new Error('Audit logs are read-only')),
  delete: () => Promise.reject(new Error('Audit logs are read-only')),
};
